import { Flex, Alert } from "antd";
import CustomButton from "../CustomButton/Button";
import "./CustomForms.scss"
import { BTN_TXT } from "../../constants/constants";

const FormFooter = ({
    onCancelClick,
    noCancel,
    onSubmitClick,
    submitLoading,
    btnName,
    btnType,
    disabled,
    error,
    rejectBtn,
    hasPerm = true,
    showSaveDraft,
    onSaveClick,
    saveLoading,
    showSkip,
    onSkipClick,
    skipLoading,
}) => {
    return (
        <Flex gap={10} justify="space-between" className="form-footer-container">
            <div>{error && <Alert message={error} type="error" showIcon />}</div>
            <Flex gap={10}>
                {rejectBtn ? (
                    <CustomButton type="danger" isSolid={true} onClick={onCancelClick}>
                        {BTN_TXT.REJECT}
                    </CustomButton>
                ) : !noCancel ? (
                    <CustomButton variant="outlinedF" onClick={onCancelClick} >
                        {BTN_TXT.CANCEL}
                    </CustomButton>
                ) : null}
                {showSaveDraft && (
                    <CustomButton variant="outlined" onClick={onSaveClick} loading={saveLoading} disabled={disabled}>
                        Save Answer
                    </CustomButton>
                )}
                {showSkip && (
                    <CustomButton
                        variant="outlined"
                        onClick={onSkipClick}
                        loading={skipLoading}
                        disabled={submitLoading || saveLoading || skipLoading}
                    >
                        {BTN_TXT.SKIP}
                    </CustomButton>
                )}
                {btnType === "danger" ? (
                    <CustomButton type="danger" isSolid={true} loading={submitLoading} htmlType="submit">
                        {btnName}
                    </CustomButton>
                ) : (btnType === "approve" || btnType === "settle" || btnType === "invoice") ? (
                    hasPerm && (
                        <CustomButton type="primary" loading={submitLoading} onClick={onSubmitClick} disabled={disabled}>
                            {btnName}
                        </CustomButton>
                    )
                ) : (
                    <CustomButton type="primary" disabled={disabled} loading={submitLoading} htmlType="submit">
                        {btnName}
                    </CustomButton>
                )}
            </Flex>
        </Flex>
    )
}

export default FormFooter